
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.152 3.992a.717.717 0 00-1.061 0L7.845 8.527 8.906 9.66l4.246-4.542a.845.845 0 000-1.126zm3.192-.008l-7.438 7.943-2.62-2.79a.717.717 0 00-1.061 0 .84.84 0 000 1.134l3.147 3.36a.717.717 0 001.061 0l7.973-8.505a.84.84 0 000-1.134h-.008a.702.702 0 00-1.054-.008zM.971 10.28l3.147 3.36a.716.716 0 001.062 0l.527-.562-3.674-3.94a.717.717 0 00-1.062 0 .85.85 0 000 1.142z","fill":"#fff"}})])
          )
        }
      }
    